import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import {Link} from 'react-router-dom'
import getLangData from '../../../utils/getLangData';
const ApplicantStatic = () => {
  return (
    <Row>
      <Col sm='12' style={{ height: '470px' }} className='d-flex'>
        <img
          className='mx-auto'
          src={require('../../../assets/images/svg/browse.svg')}
        />
      </Col>
      <Col className='d-flex mt-3'>
        <div className='mx-auto'>
          <Link to='/jobs/my-apply' className='btn btn-primary'>عرض الوظائف المقدم عليها حاليا</Link>
          <Link to='/jobs/recommendation' className='btn btn-secondary  mr-2'>البحث عن وظائف تناسب مهاراتي</Link>
        </div>
      </Col>
    </Row>
  );
};

export default ApplicantStatic;
